import { RcFile } from 'antd/lib/upload';
import { ParsedRecord } from './ImportParser';

export enum ImportView {
    INITIAL = 'initial',
    PREVIEW = 'preview',
    IMPORTING = 'importing',
    COMPLETED = 'completed',
}

export interface ViewState<T extends string> {
    view: ImportView;
    file: RcFile | null;
    records: ParsedRecord<T>[];
}

export interface ResetAction {
    type: 'reset';
}

export interface PreviewAction<T extends string> {
    type: 'preview';
    payload: {
        file: RcFile;
        records: ParsedRecord<T>[];
    };
}

export interface ImportingAction<T extends string> {
    type: 'importing';
    payload: {
        records: ParsedRecord<T>[];
    };
}

export interface CompletedAction {
    type: 'completed';
}

export type ViewStateAction<T extends string> = ResetAction | PreviewAction<T> | ImportingAction<T> | CompletedAction;

export function reducer<T extends string>(state: ViewState<T>, action: ViewStateAction<T>): ViewState<T> {
    switch (action.type) {
        case 'reset':
            return {
                ...state,
                view: ImportView.INITIAL,
                file: null,
                records: [],
            };
        case 'preview':
            return {
                ...state,
                view: ImportView.PREVIEW,
                file: action.payload.file,
                records: action.payload.records,
            };
        case 'importing':
            return {
                ...state,
                view: ImportView.IMPORTING,
                records: action.payload.records,
            };
        case 'completed':
            return {
                ...state,
                view: ImportView.COMPLETED,
            };
        default:
            return state;
    }
}
